"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @file fetch themes from api.padlet.[dev|io|com]/api/:version/themes

var json_api_fetch_1 = require("./json_api_fetch");
/**
 * Fetch Themes
 * @return Promise that resolves to a collection of Themes.
 */


function fetchThemes() {
  return (0, json_api_fetch_1.jsonApiFetch)('themes');
}

exports.default = fetchThemes;